<template>
    <div class="support-articles" :class="{loading: loading}">
        <fieldset>
            <legend>
                <div class="row">
                    <div class="col-sm-6 col-md-7 text-right form-group pull-sm-right">
                        Support Articles
                    </div>

                    <div class="col-sm-6 col-md-5 form-group align-sm-left" v-if="canModify">
                        <button type="button" class="btn btn-success" @click="openSupportArticle(null)">
                            Create Support Article
                        </button>
                    </div>
                </div>
            </legend>

            <div class="list-group">
                <a href="javascript://void(0)" class="list-group-item"
                   :class="{'list-group-item-success active':currentSupportArticleId === supportArticle.id}"
                   v-for="supportArticle in supportArticles"
                   @click="openSupportArticle(supportArticle.id)">
                    <h4>{{supportArticle.title}}</h4>
                    <h6 v-if="supportArticle.subtitle">{{supportArticle.subtitle}}</h6>
                    <span v-html="supportArticle.scopeLabel"></span>
                    <span class="label label-warning padding-sm-left" v-if="supportArticle.project_id === null">
                        All Projects
                    </span>
                </a>
            </div>
        </fieldset>

        <support-article ref="supportArticle"
                         :can-modify="canModify"
                         :support-article-id="currentSupportArticleId"
                         :project-id="projectId"
                         :afterSave="loadSupportArticles">
            <span></span>
        </support-article>
    </div>
</template>

<script>
    export default {
        props: {
            projectId: {
                required: true,
                type: String
            },

            canModify: {
                required: true,
                type: Boolean
            },
        },

        data: function(){
            return {
                loading: true,
                supportArticles: [],
                currentSupportArticleId: null,
            };
        },

        mounted: function(){
            var self = this;

            Promise.all( [
                this.loadSupportArticles(),
            ] )
                .then( function(){
                    self.loading = false;
                } );
        },

        methods: {
            loadSupportArticles: function(){
                var self = this;
                var url = '/api/supportArticles?allProjects=true&project_id=' + this.projectId + '&sort_by=name&sort_dir=ASC';

                return axios.get( url )
                    .then( function( response ){
                        self.$set( self, 'supportArticles', response.data.SupportArticles );
                    } );
            },

            openSupportArticle: function( id ){
                var self = this;
                this.currentSupportArticleId = id;

                this.$nextTick( function(){
                    self.$refs.supportArticle.openModal();
                } );
            },
        }
    }
</script>
